import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { LabelToId } from 'src/app/common/input-utils'

// Single-button boolean toggle (DESIGN.md "Pill choice... Toggle-button variant")
// — a distinct control from both PillChoiceComponent (binary Yes/No, role="radiogroup")
// and ConfirmationCheckboxComponent (Step 4-only, one-off 22×22 checkbox square). Its
// own inner text swaps 'Add'/'Included' on control.value, mirroring how PillChoiceComponent
// hardcodes 'Yes'/'No' rather than taking them as inputs. First real consumer: story
// e8-6's AdditionalServicesStepComponent.
@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  standalone: false,
})
export class ToggleButtonComponent implements OnInit {
  @Input() control: FormControl<boolean>
  @Input() label: string
  @Input() required: boolean = false
  @Input() errorText: string

  id: string
  errorId: string

  ngOnInit(): void {
    this.id = LabelToId(this.label)
    this.errorId = `${this.id}-error`
  }

  get isInvalid(): boolean {
    return (
      this.required &&
      this.control?.invalid === true &&
      this.control?.touched === true
    )
  }

  toggle(): void {
    this.control.setValue(!this.control.value)
    this.control.markAsTouched()
  }
}
